// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.input-with-validation {
  width: 100%;
  background-color: var(--color-input-background);
  color: var(--color-content-base);
  box-shadow: 0 0 0 1px var(--color-border-base), 0px -1px 1px var(--color-border-base);
  line-height: 32px;
  font-size: 14px;
  font-weight: 400;
  border-radius: 4px;
  border: none;
  height: 32px;
  padding: 0 5px;
}
.input-with-validation--disabled {
  opacity: 0.5;
}
.input-with-validation--plain {
  box-shadow: none;
}
.input-with-validation--hide-arrows::-webkit-outer-spin-button,
.input-with-validation--hide-arrows::-webkit-inner-spin-button {
  -webkit-appearance: none;
  /* Chrome & Safari */
}
.input-with-validation--hide-arrows[type=number] {
  -moz-appearance: textfield;
  /* Firefox */
}
.input-with-validation--error {
  box-shadow: 0 0 0 1px var(--color-error-shadow-base), 0px -1px 1px var(--color-error-shadow-base);
  background-color: var(--color-error-background-base);
}
.input-with-validation--variant-small {
  height: 24px;
  line-height: 24px;
  border-radius: 4px;
}
.input-with-validation--variant-medium {
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
}
.input-with-validation--variant-large {
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
}
.input-with-validation--focused,
.input-with-validation:focus {
  outline-offset: 2px;
  outline: 2px solid var(--color-outline-base);
}
.input-with-validation:focus-within {
  outline: 2px solid var(--color-outline-base);
}
.input-with-validation--status-invalid {
  box-shadow: 0 0 0 1px var(--color-error-shadow-base), 0px -1px 1px var(--color-error-shadow-base);
  background: var(--color-error-background-base);
}
.input-with-validation__input {
  border: 0;
  width: 100%;
  background: none;
  outline: none;
}
.input-with-validation--type-textarea .input-with-validation__input {
  resize: none;
}
.input-with-validation__status {
  width: 20px;
}
.input-with-validation--type-textarea .input-with-validation__status {
  margin-top: 4px;
}
.input-with-validation__status--status-valid {
  color: var(--color-success-content-base);
}
.input-with-validation__status--status-invalid {
  color: var(--color-error-content-base);
}
.input-with-validation--type-textarea {
  height: unset;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/common/ui/form-inputs/InputWithValidation.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/input.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/misc.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EACE,WAAA;ECAA,+CAAA;EACA,gCAAA;EACA,qFAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EAGE,cAAA;ADQJ;ACLE;EACE,YAAA;ADOJ;ACJE;EACE,gBAAA;ADMJ;ACFI;;EAEE,wBAAA;EDIJ,oBAAoB;AACtB;ACFI;EACE,0BAAA;EDIJ,YAAY;AACd;ACDE;EACE,iGAAA;EACA,oDAAA;ADGJ;ACAE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;ADEJ;ACCE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;ADCJ;ACEE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;ADAJ;ACGE;;EC1DA,mBAAA;EACA,4CAAA;AF2DF;AAvDE;EACE,4CAAA;AAyDJ;AAtDE;EACE,iGAAA;EACA,8CAAA;AAwDJ;AArDE;EACE,SAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AAuDJ;AArDI;EACE,YAAA;AAuDN;AAnDE;EACE,WAAA;AAqDJ;AAnDI;EACE,eAAA;AAqDN;AAlDI;EACE,wCAAA;AAoDN;AAjDI;EACE,sCAAA;AAmDN;AA/CE;EACE,aAAA;AAiDJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.input-with-validation {\n  width: 100%;\n  .neptune-input();\n\n  &:focus-within {\n    outline: 2px solid var(--color-outline-base);\n  }\n\n  &--status-invalid {\n    box-shadow: @input-box-shadow-error;\n    background: var(--color-error-background-base);\n  }\n\n  &__input {\n    border: 0;\n    width: 100%;\n    background: none;\n    outline: none;\n\n    .input-with-validation--type-textarea & {\n      resize: none;\n    }\n  }\n\n  &__status {\n    width: 20px;\n\n    .input-with-validation--type-textarea & {\n      margin-top: 4px;\n    }\n\n    &--status-valid {\n      color: var(--color-success-content-base);\n    }\n\n    &--status-invalid {\n      color: var(--color-error-content-base);\n    }\n  }\n\n  &--type-textarea {\n    height: unset;\n  }\n}\n","@import \"./../variables.less\";\n\n.neptune-input(@with-padding: true) {\n  background-color: var(--color-input-background);\n  color: var(--color-content-base);\n  box-shadow: @input-box-shadow;\n  line-height: 32px;\n  font-size: @fontSize-sm;\n  font-weight: @fontWeight-regular;\n  border-radius: @input-border-radius;\n  border: none;\n  height: 32px;\n\n  & when (@with-padding = true) {\n    padding: 0 5px;\n  }\n\n  &--disabled {\n    opacity: 0.5;\n  }\n\n  &--plain {\n    box-shadow: none;\n  }\n\n  &--hide-arrows {\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none; /* Chrome & Safari */\n    }\n\n    &[type=number] {\n      -moz-appearance: textfield; /* Firefox */\n    }\n  }\n\n  &--error {\n    box-shadow: @input-box-shadow-error;\n    background-color: @input-bg-error;\n  }\n\n  &--variant-small {\n    height: @layoutUnit-lg;\n    line-height: @layoutUnit-lg;\n    border-radius: 4px;\n  }\n\n  &--variant-medium {\n    height: @layoutUnit-xl;\n    line-height: @layoutUnit-xl;\n    border-radius: 4px;\n  }\n\n  &--variant-large {\n    height: @layoutUnit-xxl;\n    line-height: @layoutUnit-xxl;\n    border-radius: 4px;\n  }\n\n  &--focused,\n  &:focus {\n    .n-outline();\n  }\n}\n\n.neptune-input-select() {\n  .neptune-input(@with-padding: false);\n\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n\n  user-select: none;\n\n  padding: 6px 8px;\n\n  &[data-placeholder] {\n    color: var(--color-content-secondary);\n  }\n\n  &__icon {\n    color: var(--color-content-secondary);\n  }\n}\n",".n-outline() {\n  outline-offset: 2px;\n  outline: 2px solid var(--color-outline-base);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
